// Registro en memoria de las PLANILLAS que el usuario adjunta —
// ADR-2026-09-08-el-agente-lee-y-escribe-planillas.
//
// Mismo criterio que el lote de fotos (`lotesDeFotos.ts`): 5.000 filas no se persisten en
// `agent_chats` con cada mensaje del historial. En el mensaje queda un resumen (nombre,
// hojas, cuántas filas) y el contenido vive acá, en memoria de la pestaña. Tras una recarga
// no está: `ver_planilla` lo dice y ofrece volver a adjuntarla.

import type { Planilla } from './planilla';

const registro = new Map<string, Planilla>();

const nuevoId = (): string => {
  try {
    return `plan-${crypto.randomUUID().slice(0, 8)}`;
  } catch {
    return `plan-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
  }
};

export function registrarPlanilla(planilla: Planilla): string {
  const id = nuevoId();
  registro.set(id, planilla);
  return id;
}

export function obtenerPlanilla(id: string | null | undefined): Planilla | null {
  if (!id) return null;
  return registro.get(id) ?? null;
}

export function liberarPlanilla(id: string | null | undefined): void {
  if (id) registro.delete(id);
}

/**
 * Tira TODO el registro. Es lo que corre al cambiar de cuenta: el `Map` es de módulo y
 * sobrevive al remontaje del provider, así que sin esto los documentos de la cuenta
 * anterior seguían en la memoria de la pestaña
 * (ADR-2026-09-09-los-documentos-en-memoria-se-liberan). También lo usan los tests.
 */
export function vaciarRegistroDePlanillas(): void {
  registro.clear();
}
